import type { IEstimationWizardStep } from '@/context/estimationWizardContext/model.ts';
import type { MessageType } from '@/hooks/messages';

import type { NavigationMessages } from './messages';

// Setup steps for "Create new estimate" section
export const getSetupSteps = (
  messages: MessageType<typeof NavigationMessages>,
): IEstimationWizardStep[] => [
  {
    label: messages.basics(),
    contentId: 'estimation',
    link: '/estimation/new/basics',
    children: [
      {
        label: messages.project(),
        contentId: 'project',
        link: '/estimation/new/basics/project',
      },
      {
        label: messages.projectType(),
        contentId: 'project-type',
        link: '/estimation/new/basics/project-type',
      },
      {
        label: messages.methodology(),
        contentId: 'methodology',
        link: '/estimation/new/basics/methodology',
      },
    ],
  },
];

// Wizard steps for "Wizard Mode" section (after user chooses Wizard at decision point)
export const getWizardSteps = (
  messages: MessageType<typeof NavigationMessages>,
): IEstimationWizardStep[] => [
  {
    label: messages.metadata(),
    contentId: 'estimation-history',
    link: '/estimation/new/metadata',
    children: [
      {
        label: messages.metadataMandatory(),
        contentId: 'mandatory',
        link: '/estimation/new/metadata/mandatory',
      },
      {
        label: messages.metadataOptional(),
        contentId: 'optional',
        link: '/estimation/new/metadata/optional',
      },
    ],
  },
  {
    label: messages.phases(),
    contentId: 'project-phases',
    link: '/estimation/new/project-phases',
  },
  {
    label: messages.estimating(),
    contentId: 'estimating',
    link: '/estimation/new/estimating',
  },
  {
    label: messages.resourcing(),
    contentId: 'estimation-resources',
    link: '/estimation/new/resources',
  },
  {
    label: messages.costing(),
    contentId: 'estimation-costing',
    link: '/estimation/new/costs',
  },
  {
    label: messages.review(),
    contentId: 'estimation-review',
    link: '/estimation/new/review',
  },
];

// Combined steps for backward compatibility (used by wizard context)
export const getEstimationSteps = (
  messages: MessageType<typeof NavigationMessages>,
): IEstimationWizardStep[] => [...getSetupSteps(messages), ...getWizardSteps(messages)];
